import {FilteredListPageLayout} from '@github-ui/layout-primitives/FilteredListPageLayout'
import type {MouseEventHandler} from 'react'

import {LABELS} from '../constants'

export function ViewsBackLink({
  viewsPath,
  onClick,
}: {
  viewsPath: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}) {
  return (
    <FilteredListPageLayout.PageHeader.ParentLink href={viewsPath} hidden={false} onClick={onClick}>
      {LABELS.views.backToViews}
    </FilteredListPageLayout.PageHeader.ParentLink>
  )
}
